import { useGeneralStore } from '~/store'
import { resolveAgeGateState } from '~/utils/age-gate'

// plugins/age-gate.ts
export default defineNuxtPlugin(() => {
	const generalStore = useGeneralStore()

	const age = useCookie<boolean | null>('age_verified', {
		sameSite: 'lax',
		path: '/',
		secure: import.meta.env.PROD,
	})

	const resolved = resolveAgeGateState(age.value)
	generalStore.SET_STATE_GENERAL({ type: 'is_adult', value: resolved.isAdult })
	generalStore.SET_STATE_GENERAL({ type: 'show_modal_age_verification', value: resolved.showModal })
})
